<div class="calendar">
  <ion-card button (click)="select(i)" *ngFor="let item of dates; let i = index">
    <ion-card-content class="ion-no-padding ion-no-margin">
      <h3 [ngClass]="{ selected: selected[i] }">
        <strong>{{ item | date : 'MMM' }}</strong>
      </h3>
      <h1 [ngClass]="{ selected: selected[i] }">{{ item | date : 'dd' }}</h1>
      <h5 [ngClass]="{ selected: selected[i] }">{{ item | date : 'HH:mm' }}</h5>
    </ion-card-content>
  </ion-card>
</div>
